import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface NotificationItem {
  id: string;

  type:
  | "success"
  | "error"
  | "warning"
  | "info";

  message: string;
}

interface NotificationState {
  notifications:
  NotificationItem[];
}

const initialState: NotificationState = {
  notifications: [],
};

const notificationSlice =
  createSlice({
    name: "notification",

    initialState,

    reducers: {
      addNotification: (
        state,
        action:
          PayloadAction<NotificationItem>,
      ) => {
        state.notifications.push(
          action.payload,
        );
      },

      removeNotification: (
        state,
        action:
          PayloadAction<string>,
      ) => {
        state.notifications =
          state.notifications.filter(
            (item) =>
              item.id !==
              action.payload,
          );
      },

      clearNotifications: (
        state,
      ) => {
        state.notifications = [];
      },
    },


  });

export const {
  addNotification,
  removeNotification,
  clearNotifications,
} = notificationSlice.actions;

export default notificationSlice.reducer;
